import { useCallback } from 'react';

/**
 * Hook for retry logic with exponential backoff
 */
export const useRetry = () => {
  const sleep = useCallback((ms: number) => new Promise((resolve) => setTimeout(resolve, ms)), []);

  const fetchWithRetry = useCallback(
    async <T,>(fn: () => Promise<T>, retries = 4, baseDelayMs = 500): Promise<T> => {
      let attempt = 0;
      while (true) {
        try {
          return await fn();
        } catch (e: any) {
          const isNetworkError = !e.response;
          if (attempt >= retries || !isNetworkError) {
            throw e;
          }
          const delay = baseDelayMs * Math.pow(2, attempt);
          await sleep(delay);
          attempt += 1;
        }
      }
    },
    [sleep]
  );

  return { fetchWithRetry };
};

